import { Box, Container, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const FooterWrapper = styled(Box)(
  ({ theme }) => `
        border-radius: 0;
        padding: ${theme.spacing(1)} 0;

        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
);

function Footer() {
  return (
    <FooterWrapper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        zIndex: (theme) => theme.zIndex.appBar
      }}
    >
      <Container maxWidth="xl">
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems="center"
          justifyContent="space-between"
          textAlign="center"
          gap={0.5}
        >
          <Typography variant="subtitle1">
            &copy; 2021 - SIGMA - Parte de la Familia Domo
          </Typography>
          <Typography variant="subtitle1">
            Desarrollado por{' '}
            <Link
              href="https://domodelta.com.ar"
              target="_blank"
              rel="noopener noreferrer"
            >
              Domo Gestion
            </Link>
          </Typography>
        </Box>
      </Container>
    </FooterWrapper>
  );
}

export default Footer;
